// ----------------------------------------------------------------------
// <copyright file="Izenda.CheckboxAllPermission.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var connect = require('share/enhancers/Izenda.Connect');
  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');
  var EventsUtils = require('EventUtils');
  var m = require('mobx-react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var SelectAllPermissionCheckBox = m.observer(function (props) {
    var notifyChange = EventsUtils.notifyChange;
    var permission = props.permission;
    var section = props.section;
    var tenantPermission = props.tenantPermission;

    var isIndeterminate = permission.isTenantSetup 
      ? permission.isAllTenantSectionIndeterminate(section) 
      : permission.isAllRoleSectionIndeterminate(section, tenantPermission);

    var isChecked = permission.isTenantSetup 
      ? permission.isAllTenantSectionChecked(section) 
      : permission.isAllRoleSectionChecked(section, tenantPermission);

    var onChangeCheckbox = permission.isTenantSetup 
      ? notifyChange(permission.updateAllTenantSection.bind(permission, section), EventsUtils.CHECKBOX)
      : notifyChange(permission.updateAllRoleSection.bind(permission, section, tenantPermission), EventsUtils.CHECKBOX);
     
     return (
        <Input
          type='checkbox'
          readOnly={props.readOnly}
          indeterminate={isIndeterminate}
          checked={isChecked}
          onChange={onChangeCheckbox} />
      )
  })

  var CheckboxAllPermission = function (props) {
    var permission = props.permission;
    var notifyChange = EventsUtils.notifyChange;
    var localization = this.props.localization;

    //For select all section role or tenant
    if(!props.selectAllPermimssion) {
      return (                
        <label className="u_noBorderAll">
          <SelectAllPermissionCheckBox {...props}/>
          <span className="u_marginLeftRight u_textNormal">{localization.getText('TENANT_SELECT_ALL')}</span>  
         </label>
      )
    }

    //For select all tenant setup
    return(
        <div className="u_paddingLeftRight u_borderBottom">
          <GridLayout>
            <GridLayout.Row className="u_noBorder">
              <GridLayout.Col cols={11}>
                <label className="u_noBorderAll">
                  <SelectAllPermissionCheckBox {...props}/>
                  <span className="u_marginLeftRight u_textNormal">{localization.getText('TENANT_SELECT_ALL')}</span>  
                </label>
              </GridLayout.Col>
              <GridLayout.Col cols={1} className="u_textCenter">
              {permission.isTenantSetup && props.selectAllPermimssion && 
              <Input
                indeterminate={permission.isAllTenantIndeterminate(permission)}
                type='checkbox'
                readOnly={props.readOnly}
                checked={permission.isAllTenantAccessChecked(permission) }
                onChange={notifyChange(permission.updateAllTenantAccess.bind(permission, permission), EventsUtils.CHECKBOX) } />}
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        </div>
    )
  }

  CheckboxAllPermission.displayName = 'CheckboxAllPermission';

  CheckboxAllPermission.propTypes = {
    selectAllPermimssion: React.PropTypes.bool,
    permission: React.PropTypes.object.isRequired,
    section: React.PropTypes.object.isRequired,
    tenantPermission: React.PropTypes.object
  };

  module.exports = connect()(CheckboxAllPermission);
  }());




// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.CheckboxAllPermission.jsx